
const DATUM_STORE_TIMEZONE = "Asia/Kolkata";

function getSessionId() {
  const KEY = "datum_session";
  const now = new Date();

  let stored = JSON.parse(localStorage.getItem(KEY));

  if (!stored) return createNewSession();

  const lastActivity = new Date(stored.last_activity);

  const inactive = now - lastActivity > 30 * 60 * 1000;

  const currentDate = now.toLocaleDateString("en-US", {
    timeZone: DATUM_STORE_TIMEZONE
  });

  const lastDate = lastActivity.toLocaleDateString("en-US", {
    timeZone: DATUM_STORE_TIMEZONE
  });

  const crossedMidnight = currentDate !== lastDate;

  if (inactive || crossedMidnight) {
    return createNewSession();
  }

  stored.last_activity = now;
  localStorage.setItem(KEY, JSON.stringify(stored));

  return stored.session_id;
}

function createNewSession() {
  const session = {
    session_id: crypto.randomUUID(),
    last_activity: new Date()
  };

  localStorage.setItem("datum_session", JSON.stringify(session));

  return session.session_id;
}

async function sha256(message) {
  const msgBuffer = new TextEncoder().encode(message);

  const hashBuffer = await crypto.subtle.digest(
    "SHA-256",
    msgBuffer
  );

  return Array.from(new Uint8Array(hashBuffer))
    .map(b => b.toString(16).padStart(2, "0"))
    .join("");
}

async function generateIdempotencyKey(eventType, cartToken, variantId) {
  const bucket = Math.floor(Date.now() / 1000);

  const raw = `${eventType}:${cartToken}:${variantId}:${bucket}`;

  return await sha256(raw);
}

async function getCartToken() {
  try {
    const res = await fetch("/cart.js");
    const cart = await res.json();

    return cart.token;
  } catch {
    return null;
  }
}

async function trackEvent(eventType, variantId = null, url = null, data = null) {
  console.log("Tracking Event:", eventType);

  // Safety fallback
  if (!eventType || typeof eventType !== "string") {
    console.warn("Invalid eventType passed:", eventType);
    return;
  }

  const cartToken = await getCartToken();

  if (!cartToken) return;

  const idempotencyKey = await generateIdempotencyKey(
    eventType,
    cartToken,
    variantId || "checkout"
  );

  const payload = {
    event_id: crypto.randomUUID(),
    idempotency_key: idempotencyKey,
    event_type: eventType,
    session_id: getSessionId(),
    cart_token: cartToken,
    variantId: variantId,
    user_agent: navigator.userAgent,
    shop_name: "shyle",
    url: url,
    data: data,
    timestamp: new Date().toISOString()
  };

  console.log("Tracking Payload:", payload);

  fetch("https://api.trytechit.co/main/track", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(payload)
  });
}

// Track xyz_new_event
function onDatumXyzNewEvent(e, variantIds = "") {
  trackEvent("xyz_new_event", variantIds);
}

// Example: track xyz_new_event on a click
document.addEventListener("click", function (e) {
  if (e.target.id === "gokwik-buy-now") {
    const variantId =
      e.target.closest("form")
        ?.querySelector('input[name="id"]')
        ?.value || null;

    trackEvent("xyz_new_event", variantId);
  }
});
